import React, { useState } from "react";
import { useActiveBar } from "../ActiveBarContext";
import { useAuth } from "../../AuthContext";
import { auth } from "../../firebase";
import PlanCancel from "../shared/PlanCancel";

const CHECKOUT_URL =
  "https://us-central1-bar-buzz-a6645.cloudfunctions.net/createFeaturedCheckoutSession";
const UPDATES_URL =
  "https://us-central1-bar-buzz-a6645.cloudfunctions.net/createUpdatesCheckout";

export default function Subscription() {
  const { myBars, activeBar } = useActiveBar();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGetFeatured = async () => {
    if (!activeBar) return;
    setError("");
    setLoading(true);
    try {
      const res = await fetch(CHECKOUT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          barId: activeBar.id,
          barName: activeBar.name,
          ownerEmail: user?.email || "",
        }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError(data.error || "Something went wrong creating checkout. Try again.");
        setLoading(false);
      }
    } catch (err) {
      console.error("Featured checkout error:", err);
      setError("Something went wrong. Try again.");
      setLoading(false);
    }
  };

  // "We Post It For You" ($10/month): they email updates, we post them.
  const [updLoading, setUpdLoading] = useState(false);
  const [updError, setUpdError] = useState("");
  const handleUpdates = async () => {
    if (!activeBar) return;
    setUpdError("");
    setUpdLoading(true);
    try {
      const token = await auth.currentUser?.getIdToken();
      const res = await fetch(UPDATES_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ barId: activeBar.id }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else {
        setUpdError(data.error || "Something went wrong creating checkout. Try again.");
        setUpdLoading(false);
      }
    } catch (err) {
      setUpdError("Something went wrong. Try again.");
      setUpdLoading(false);
    }
  };

  const planCard = {
    padding: "24px",
    borderRadius: "18px",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  };
  const list = { margin: 0, paddingLeft: "20px", display: "flex", flexDirection: "column", gap: "8px", fontSize: "16px" };

  if (myBars.length === 0) {
    return <p style={{ color: "#fff", fontSize: "16px" }}>Claim a bar first, then you can upgrade it here.</p>;
  }

  return (
    <div style={{ color: "#fff", maxWidth: "1000px", display: "flex", flexDirection: "column", gap: "24px" }}>
      <div>
        <h1 style={{ margin: 0, fontFamily: "'Bebas Neue', Inter, sans-serif", fontWeight: 400, fontSize: "44px", letterSpacing: "0.5px" }}>
          Get more people in the door
        </h1>
        <p style={{ margin: "4px 0 0", fontSize: "17px", color: "#ACA8BF" }}>
          Posting is always free. Upgrade {activeBar?.name || "your bar"} when you want extra reach.
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "16px" }}>
        <section style={{ ...planCard, background: "#17131F", border: "1px solid #3A3350" }}>
          <div style={{ fontSize: "15px", fontWeight: 700, letterSpacing: "1px", color: "#ACA8BF" }}>FREE</div>
          <div style={{ fontSize: "34px", fontWeight: 700 }}>$0</div>
          <ul style={{ ...list, color: "#D6D2E4" }}>
            <li>Your bar listed for everyone nearby</li>
            <li>Unlimited events, specials and food photos</li>
            <li>Staff posting code</li>
            <li>Job postings</li>
            <li>Weekly report by email every Monday: who saw, tapped and saved your bar</li>
          </ul>
          {!activeBar?.featured && !activeBar?.managedUpdates && (
            <div style={{ marginTop: "auto", minHeight: "48px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px", border: "1px solid #3A3350", color: "#ACA8BF" }}>
              Your current plan
            </div>
          )}
        </section>

        <section style={{ ...planCard, background: "#17131F", border: "1px solid #8B5CF6" }}>
          <div style={{ fontSize: "15px", fontWeight: 700, letterSpacing: "1px", color: "#B9A6FF" }}>WE POST IT FOR YOU</div>
          <div style={{ fontSize: "34px", fontWeight: 700 }}>
            $10 <span style={{ fontSize: "17px", fontWeight: 500, color: "#ACA8BF" }}>/ month</span>
          </div>
          <ul style={{ ...list, color: "#D6D2E4" }}>
            <li>Everything in Free</li>
            <li>No computer needed: email or text us your specials and events</li>
            <li>We put them in the app for you, usually the same day</li>
            <li>Great if you don't have a website</li>
          </ul>
          {updError && <p style={{ color: "#f87171", margin: 0 }}>{updError}</p>}
          {activeBar?.managedUpdates ? (
            <div style={{ marginTop: "auto" }}>
              <p style={{ margin: "0 0 6px", color: "#4ade80", fontWeight: 700 }}>✓ You're on We Post It For You</p>
              <p style={{ margin: 0, fontSize: "15px", color: "#ACA8BF" }}>
                Send updates to <a href="mailto:updates@barfunfinder.com" style={{ color: "#FF6FA3" }}>updates@barfunfinder.com</a>
              </p>
              <PlanCancel barId={activeBar.id} plan="updates" planName="We Post It For You" />
            </div>
          ) : (
            <button
              type="button"
              onClick={handleUpdates}
              disabled={updLoading}
              style={{
                marginTop: "auto", minHeight: "52px", borderRadius: "12px", border: "1px solid #8B5CF6",
                background: "transparent", color: "#fff", font: "700 17px Inter, sans-serif",
                cursor: updLoading ? "default" : "pointer", opacity: updLoading ? 0.6 : 1,
              }}
            >
              {updLoading ? "Opening checkout…" : "Sign up for $10/month"}
            </button>
          )}
          {!activeBar?.managedUpdates && (
            <p style={{ margin: "10px 0 0", fontSize: "15px", color: "#ACA8BF" }}>
              At checkout you'll give us permission to post for your bar.{" "}
              <a href="https://barfunfinder.com/posting-permission.html" target="_blank" rel="noreferrer" style={{ color: "#FF6FA3" }}>
                Read what that means
              </a>
            </p>
          )}
        </section>

        <section style={{ ...planCard, background: "#1E1428", border: "2px solid #FF3D81" }}>
          <div style={{ fontSize: "15px", fontWeight: 700, letterSpacing: "1px", color: "#FF6FA3" }}>PRO</div>
          <div style={{ fontSize: "34px", fontWeight: 700 }}>
            $39 <span style={{ fontSize: "17px", fontWeight: 500, color: "#ACA8BF" }}>/ month</span>
          </div>
          <ul style={list}>
            <li>Everything in Free</li>
            <li>Shown first to customers near you</li>
            <li>2 free event boosts every month ($20 value)</li>
          </ul>

          {error && <p style={{ color: "#f87171", margin: 0 }}>{error}</p>}

          {activeBar?.featured ? (
            <div style={{ marginTop: "auto" }}>
              <p style={{ margin: "0 0 6px", color: "#4ade80", fontWeight: 700 }}>✓ This bar is on Pro</p>
              <PlanCancel barId={activeBar.id} plan="pro" planName="Pro" />
            </div>
          ) : (
            <button
              type="button"
              onClick={handleGetFeatured}
              disabled={loading}
              style={{
                marginTop: "auto", minHeight: "52px", border: "none", borderRadius: "12px",
                background: "#FF3D81", color: "#0B0B12", font: "700 17px Inter, sans-serif",
                cursor: loading ? "default" : "pointer", opacity: loading ? 0.6 : 1,
              }}
            >
              {loading ? "Opening checkout…" : "Upgrade to Pro"}
            </button>
          )}
        </section>
      </div>

      <section style={{ padding: "20px", borderRadius: "14px", border: "1px dashed #5A5070", display: "flex", flexWrap: "wrap", alignItems: "center", gap: "14px" }}>
        <div style={{ flex: "1 1 320px", minWidth: 0 }}>
          <div style={{ fontSize: "17px", fontWeight: 700 }}>Want to be the featured bar for your region or all of Minnesota?</div>
          <div style={{ fontSize: "15px", color: "#ACA8BF", marginTop: "4px" }}>Limited spots. We'll set it up with you personally.</div>
        </div>
        <a href="mailto:hello@barfunfinder.com?subject=Featured%20bar%20spot" style={{ minHeight: "48px", display: "flex", alignItems: "center", padding: "0 18px", borderRadius: "12px", background: "#17131F", border: "1px solid #3A3350", color: "#fff", textDecoration: "none", fontWeight: 600 }}>
          Talk to us
        </a>
      </section>
    </div>
  );
}
